import { createAction, props } from "@ngrx/store";
import { AnalyticsEventProps } from "src/app/core/analytics/interfaces";

export const trackEvent = createAction("[Analytics] Track event", props<AnalyticsEventProps>());
